var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "c-resizable" }, [
      _c(
        "div",
        { staticClass: "resizable-container", class: _vm.containerClass },
        [
          _c("div", { staticClass: "header" }, [_vm._t("header")], 2),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "contentRef",
              staticClass: "content",
              style: { height: _setup.height },
            },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "resize-handle", on: { mousedown: _setup.startResize } },
      [_c("font-awesome-icon", { attrs: { icon: "fa-solid fa-grip-dots" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }